export default __webpack_public_path__ + "static/portfolio_gallery_4-c80c4a6eacb4779c5c929946c2b0169e.jpg";